import { useEffect, useState } from "react";
import { message, Card, Form, Select, Input, DatePicker, Row, Col, Button, Flex, Upload } from "antd";
import { dateFormat, menuLinks, notifyMessages, requiredMessages } from "../../utils/constants";
import { UploadOutlined } from "@ant-design/icons";
import { PageHeader } from "../../components/common/pageHeader";
import { Link, useNavigate } from "react-router";
import { SaveOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useCurrentUserContext } from "../../context/currentUserContext";
import dayjs from 'dayjs';
import FgasDocumentsServices from "../../services/fgasDocumentServices";
import { handleDateConvertForApis } from "../../utils/functions";
import { fetchSuppliersList } from "../../state/slices/suppliersListSlice";

const NewFgasDocument = () => {

    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [fieldsChanged, setFieldsChanged] = useState(false);
    const [loadingButton, setLoadingButton] = useState(false);
    const { currentUser } = useCurrentUserContext();
    const [uploadedFile, setUploadedFile] = useState(null);
    const [fileList, setFileList] = useState([]);
    const dispatch = useDispatch();

    const suppliersList = useSelector(state => state.suppliers.suppliers);
    const anomaliesList = useSelector(state => state.anomalies.anomalies);
    const intervetionTypesList = useSelector(state => state.intervetionTypes.intervetionTypes);

    useEffect(() => {
        if (!currentUser) return;
        dispatch(fetchSuppliersList(currentUser.lastSelectedCategory, false, currentUser.id));
    }, [dispatch, currentUser]);

    const saveData = async (values) => {
        const formData = new FormData();
        values["LastEditedUser"] = currentUser.id;
        values.DateAdded = handleDateConvertForApis(values.DateAdded);       

        formData.append("Document_FGAS_Model", JSON.stringify(values));

        if (values.pdf) {
            // formData.append("Attachment", uploadedFile);
            formData.append("Attachment", values.pdf[0].originFileObj);
        }

        if (values.fileCommunicazione) {
            // formData.append("Attachment", uploadedFile);
            formData.append("FileCommunicazione", values.fileCommunicazione[0].originFileObj);
        }
        
        setLoadingButton(true);
        try {
            const respData = await FgasDocumentsServices.addDocument(formData);
            if (respData.success) {
                message.success(notifyMessages.operationSuccess);
                navigate(menuLinks.fgas);
            } else {
                message.error(respData.ErrorDetail?.ErrorMessage || notifyMessages.errorAccured);
            }
        } catch (error) {
            message.error(notifyMessages.errorAccured);           
        }
        finally{
             setLoadingButton(false);
        }
    };

    const onSupplierChange = (option) => {
        //  const selectedOption = suppliersList.filter(supplier => supplier.value === option);         
        // form.setFieldsValue({ Code: selectedOption[0].vatCode || "" });
    }

    const beforeUpload = (file) => {
        setUploadedFile(file);
        setFileList([file]);
        return false;
    }

    const onRemove = () => {
        setUploadedFile(null);
        setFileList([]);
    };


    const handleFileChange = (info) => {
        if (info.file.status === "removed") {
            setUploadedFile(null);
            setFileList([]);
        } else {
            setUploadedFile(info.file);
            setFileList([...info.fileList]);
            if (info.file.status === "done") {
                message.success(`${info.file.name} file uploaded successfully`);
            } else if (info.file.status === "error") {
                message.error(`${info.file.name} file upload failed.`);
            }
        }
    };

    return (
        <div className="add-document">
            <PageHeader title={"Carica nuovo documento"} />
            <>
                <Card title="Dati documento" size="small" >
                    <Form
                        id="addDocument"
                        form={form}
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 8 }}
                        onFinish={(values) => { saveData(values) }}
                        onValuesChange={() => setFieldsChanged(true)}
                    >

                        <Form.Item
                            label="Codice"
                            name="Code"
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="Data caricamento"
                            name="DateAdded"
                            rules={[{ required: true, message: requiredMessages.requiredField }]}
                            initialValue={dayjs()}
                        >
                            <DatePicker format={dateFormat} />
                        </Form.Item>

                        <Form.Item
                            label="Anomalia"
                            name="AnomalyId"
                        >
                            <Select
                                allowClear
                                showSearch
                                optionFilterProp="label"
                                options={anomaliesList}
                            />
                        </Form.Item>

                        <Form.Item
                            label="Batch"
                            name="Flux"
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="Manutentore"
                            name="SupplierId"
                            rules={[{ required: true, message: requiredMessages.requiredField }]}
                        >
                            <Select
                                options={suppliersList}
                                allowClear
                                showSearch
                                optionFilterProp="label"
                                onChange={(option) => onSupplierChange(option)}
                            />
                        </Form.Item>

                        <Form.Item
                            label="Operatore"
                            name="Operatore"
                            rules={[{ required: true, message: requiredMessages.requiredField }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="PIVA / CF Operatore"
                            name="PIVA_Operatore"
                            rules={[{ required: true, message: requiredMessages.requiredField }]}
                        >
                            <Input />
                        </Form.Item>


                        <Form.Item
                            label="Intervento"
                            name="InterventionTypeId"
                            rules={[{ required: true, message: requiredMessages.requiredField }]}
                        >
                            <Select
                                allowClear
                                showSearch
                                optionFilterProp="label"
                                options={intervetionTypesList}
                            />
                        </Form.Item>

                        {/* <Form.Item
                            label="Batch"
                            name="Flux"
                        >
                            <Input />
                        </Form.Item> */}

                        <Form.Item
                            label="Note"
                            name="Notes"
                        >

                            <Input.TextArea rows={3} />
                        </Form.Item>

                        <Form.Item
                            label="Carica pdf"
                            name="pdf"
                            rules={[{ required: true, message: requiredMessages.requiredField }]}
                            valuePropName="fileList"
                            getValueFromEvent={(e) => e && e.fileList}
                        >
                            <Upload
                                maxCount={1}
                                accept='.pdf'
                                beforeUpload={beforeUpload}
                                fileList={fileList}
                                onChange={handleFileChange}
                                onRemove={onRemove}
                            >
                                <Button icon={<UploadOutlined />}>Seleziona PDF</Button>
                            </Upload>
                        </Form.Item>

                        <Form.Item
                            label="Carica file comunicazione"
                            name="fileCommunicazione"
                            valuePropName="fileList"
                            getValueFromEvent={(e) => e && e.fileList}
                        >
                            <Upload
                                maxCount={1}
                                accept='.pdf'
                                beforeUpload={beforeUpload}
                                fileList={fileList}
                                onChange={handleFileChange}
                                onRemove={onRemove}
                            >
                                <Button icon={<UploadOutlined />}>Seleziona PDF</Button>
                            </Upload>
                        </Form.Item>
                    </Form>
                </Card>

                <Row gutter={24}>
                    <Col span={24} className="modifyDocButtons">
                        <Flex gap="small" wrap>
                            <Button type="default">
                                <Link to={menuLinks.fgas}>Annulla</Link>
                            </Button>

                            <Button
                                loading={loadingButton}
                                type="primary"
                                htmlType="submit"
                                disabled={!fieldsChanged}
                                form="addDocument"
                            >
                                <SaveOutlined /> Salva
                            </Button>
                        </Flex>
                    </Col>
                </Row>
            </>
        </div>
    );
};

export default NewFgasDocument;
